module.exports = __webpack_public_path__ + "img/paypal.1cbe3eea.svg";